import generateFilename from "./generateFilename";

export default (file) => {
  const newName = generateFilename(file.name);
  const newFile = new File([file], newName, { type: file.type });
  return newFile;
};
